import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { handleNavigate, verifyEmail } from "../utilities/handleNavigate";
import "./Header.scss";
import { logoImg, messageimg } from "../assets/icons";
import { Modal } from "react-bootstrap";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { IoReorderThreeOutline } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { toast } from "sonner";

const Header = () => {
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const [isScroll, setIsScroll] = useState(false);
  const navigate = useNavigate();
  const [toggleIcon, setToggleIcon] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [value, setValue] = useState();

  useEffect(() => {
    document.body.classList.toggle("innerside_toogle", toggleIcon);
  }, [toggleIcon]);

  // Scroll header
  useEffect(() => {
    const handleScroll = () => {
      setIsScroll(window.scrollY > 30);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    description: "",
  });

  // on change handler
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // validation
  const handleValidation = () => {
    let status = true;
    let error = {};
    if (!formData.firstName) {
      error["firstName"] = "First Name is required";
      status = false;
    }
    if (!formData.lastName) {
      error["lastName"] = "Last Name is required";
      status = false;
    }
    if (!formData.email) {
      error["email"] = "Email is required";
      status = false;
    } else if (!verifyEmail(formData.email)) {
      toast.error("Please enter valid email");
      status = false;
    }

    if (!formData.mobile) {
      error["mobile"] = "Mobile is required";
      status = false;
    }
    console.log(error);

    setError(error);
    return status;
  };

  // form submission
  const formSubmitHandler = async (e) => {
    try {
      e.preventDefault();
      if (handleValidation()) {
        setLoading(true);

        const fetchResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/api/contact-us`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              firstName: formData.firstName,
              cantactNo: formData.mobile,
              lastName: formData.lastName,
              email: formData.email,
              description: formData.description,
            }),
          }
        );

        const finalResponse = await fetchResponse.json();

        if (finalResponse?.code === 200) {
          toast.success(finalResponse.message);
          setModalShow(false);
          setFormData({
            firstName: "",
            lastName: "",
            mobile: "",
            email: "",
            description: "",
          });
        } else {
          toast.error(finalResponse.message);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <header className={`header ${isScroll ? "scrollHeader" : ""}`}>
      <div className="container">
        <div className="header_content">
          <div className="logo">
            <Link to="/">
              <img src={logoImg} alt=""></img>
            </Link>
          </div>
          <div className="header_ul_btn_wrap">
            <nav className="header_menu">
              <ul>
                <li>
                  <Link
                    to="/"
                    id=""
                    onClick={() => {
                      handleNavigate("/", "#about", navigate);
                      setToggleIcon(!toggleIcon);
                    }}
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/"
                    id=""
                    onClick={() => {
                      handleNavigate("/", "#service", navigate);
                      setToggleIcon(!toggleIcon);
                    }}
                  >
                    Services
                  </Link>
                </li>
                <li>
                  <Link
                    to="/"
                    id=""
                    onClick={() => {
                      handleNavigate("/", "#testimonial", navigate);
                      setToggleIcon(!toggleIcon);
                    }}
                  >
                    Testimonial
                  </Link>
                </li>
                <li>
                  <Link
                    to="/"
                    id=""
                    onClick={() => {
                      handleNavigate("/", "#faq", navigate);
                      setToggleIcon(!toggleIcon);
                    }}
                  >
                    FAQ
                  </Link>
                </li>
              </ul>
            </nav>
            <div className="button_wrap">
              <button className="button" onClick={() => setModalShow(true)}>
                Let’s Talk
              </button>
            </div>
          </div>
          <div
            className="menu_button"
            onClick={() => setToggleIcon(!toggleIcon)}
          >
            <IoReorderThreeOutline className="three_line" />
            <RxCross2 className="cross_icon" />
          </div>
        </div>
      </div>
      <Modal
        show={modalShow}
        size="md"
        onHide={() => setModalShow(false)}
        aria-labelledby="contained-modal-title-vcenter"
        className="godide_modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <div className="wrap_head">
              <h4>Let’s Talk</h4>
              <span>You can reach us anytime</span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id="contact-us-form" onSubmit={formSubmitHandler}>
            <div className="form_field_wrap">
              <div className="form_field">
                <input
                  className="input form-control"
                  type="text"
                  id="first-name"
                  placeholder="First Name*"
                  required
                  maxLength={20}
                  name="firstName"
                  value={formData.firstName}
                  onChange={onChangeHandler}
                />
              </div>
              <div className="form_field">
                <input
                  className="input form-control"
                  type="text"
                  placeholder="Last Name*"
                  id="last-name"
                  required
                  maxLength={20}
                  name="lastName"
                  value={formData.lastName}
                  onChange={onChangeHandler}
                />
              </div>
            </div>
            <div className="form_field cstm_set">
              <input
                className="input form-control"
                type="email"
                placeholder="Your email*"
                required
                id="email"
                name="email"
                value={formData.email}
                onChange={onChangeHandler}
              />
              <span>
                <img src={messageimg} alt="" />
              </span>
            </div>
            <div className="form_field">
              <PhoneInput
                defaultCountry="ZA"
                className="input form-control"
                placeholder="Enter phone number"
                value={formData.mobile}
                onChange={(value) =>
                  setFormData({ ...formData, mobile: value })
                }
                type="tel"
                required
                id="mobile"
                name="mobile"
              />
            </div>
            <div className="form_field">
              <textarea
                className="input form-control"
                rows={6}
                placeholder="Tell us what can we help you..."
                type="tel"
                id="message"
                name="description"
                value={formData.description}
                onChange={onChangeHandler}
              />
            </div>
            <button className="button w-100" type="submit" disabled={loading}>
              {loading ? "Loading..." : "Send"}
            </button>
          </form>
        </Modal.Body>
        {/* <Modal.Footer></Modal.Footer> */}
      </Modal>
    </header>
  );
};

export default Header;
